/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCurrentUserParksQuery } from '../../models/get-current-user-parks-query';
import { GetCurrentUserParksQueryResult } from '../../models/get-current-user-parks-query-result';

export interface ApiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Params {
      body?: GetCurrentUserParksQuery
}

export function apiNurseryManagerOrderStakeholderGetCurrentUserParksPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderGetCurrentUserParksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCurrentUserParksQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderGetCurrentUserParksPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCurrentUserParksQueryResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderGetCurrentUserParksPost.PATH = '/api/NurseryManager/OrderStakeholder/GetCurrentUserParks';
